// extracted by mini-css-extract-plugin
export default {"wrapper":"Setup_wrapper__LBFgq","cardWrapper":"Setup_cardWrapper__s9wgK"};